<template>
  <div class="forum">
    <homeHead></homeHead>
    <homeNav :routerName="'forum'"  ></homeNav>
    <div class="colspan">
      <div class="weizhi">
        <img src="../../assets/images/weizhi.png" alt /> 您当前所在的位置：
      </div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item,index) in positionData" :key="index">{{item.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="list" class="list-box">
      <div class="sidebar">
        <ul>
          <li
            :class="{active:item.id==navId}"
            @click="tabClick(item)"
            v-for="(item,index) in sidebarList"
            :key="index"
          >
            {{item.name}}
            <span class="right">
              <i class="el-icon-arrow-right"></i>
            </span>
          </li>
        </ul>
      </div>
      <div v-if="navId==1" class="topic_box">
        <div class="topic_top">
          <div class="title">
            <img src="../../assets/images/zhuzhou/news.png" alt /> 话题
          </div>
          <div class="button" @click="goAnchor">
            <img src="../../assets/images/zhuzhou/pinglun.png" alt />发布话题
          </div>
        </div>
        <div class="topic_content">
          <ul>
            <li v-for="(item,index) in infoList" :key="index">
              <div class="content_title">
                <i v-if="item.if_top==1" class="icon">置顶</i>
                <div v-else class="symbol">#</div>
                <router-link :to="{ path: '/forumInfo',query:{pId:item.id} }">
                  <h3>{{item.title}}</h3>
                </router-link>
              </div>
              <p class="content_info" v-html="item.content"></p>
              <div class="image_box">
                <img
                  v-for="(itm,index) in item.pictures"
                  :key="index"
                  v-image-preview
                  :src="itm"
                  alt
                />
              </div>
              <div class="content_bottom">
                <div class="date">{{item.created_at}}</div>
                <div class="bottom_icon">
                  <div>
                    <img src="../../assets/images/zhuzhou/icon2.png" alt />
                    {{item.view_count}}
                  </div>

                  <div class="comment">
                    <router-link :to="{ path: '/forumInfo',query:{pId:item.id} }">
                      <img src="../../assets/images/zhuzhou/icon4.png" alt />
                      {{item.comment_count}}
                    </router-link>
                  </div>
                  <div
                    v-if="!access_token||item.if_favorite==0"
                    @click="favoriteClick(item.id,navId)"
                    class="thumb"
                  >
                    <img src="../../assets/images/zhuzhou/icon8.png" alt />
                    <span class="no-like">{{item.favorite_count}}</span>
                  </div>
                  <div v-else @click="deletFavorite(item.id,navId)" class="thumb">
                    <img src="../../assets/images/zhuzhou/icon3.png" alt />
                    <span>{{item.favorite_count}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div id="publish" class="publish clearfix">
          <div class="publish_title"># 发布话题 #</div>
          <div v-if="access_token" class="subject">
            <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" class="demo-ruleForm2">
              <el-form-item prop="title">
                <el-input maxlength="64" v-model="ruleForm2.title" placeholder="# 请输入你要发布的话题 #"></el-input>
              </el-form-item>
              <el-form-item prop="content">
                <vue-ueditor-wrap v-model="ruleForm2.content" :destroy="true" :config="myConfig"></vue-ueditor-wrap>
              </el-form-item>
            </el-form>
            <div class="btn" @click="submitClick('ruleForm2')">发布</div>
          </div>
          <div v-else class="login">
            请
            <span @click="dialogVisible = true">登录</span>发布话题
          </div>
        </div>
      </div>
      <div v-else-if="navId==2" class="reply_box">
        <div class="reply_top">
          <div class="title">
            <img src="../../assets/images/zhuzhou/news.png" alt /> 发帖纪录
          </div>
          <el-select @change="handleSelect(1)" v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="reply_content">
          <ul v-if="access_token&&postList.length>0">
            <li v-for="(item,index) in postList" :key="index">
              <img v-if="item.audit_status==1" src="../../assets/images/audit.png" alt />
              <img v-else-if="item.audit_status==3" src="../../assets/images/audit2.png" alt />
              <router-link :to="{ path: '/forumInfo',query:{pId:item.id,title:item.title} }">
                <h3>
                  <span>#</span>
                  {{item.title}}
                </h3>
              </router-link>
              <div class="content_bottom">
                <div class="date">{{item.created_at}}</div>
                <div class="bottom_icon">
                  <div>
                    <img src="../../assets/images/zhuzhou/icon2.png" alt />
                    {{item.view_count}}
                  </div>
                  <div>
                    <router-link :to="{ path: '/forumInfo',query:{pId:item.id} }">
                      <img src="../../assets/images/zhuzhou/icon4.png" alt />
                      {{item.comment_count}}
                    </router-link>
                  </div>
                  <div
                    v-if="!access_token||item.if_favorite==0"
                    @click="favoriteClick(item.id,navId)"
                    class="thumb"
                  >
                    <img src="../../assets/images/zhuzhou/icon8.png" alt />
                    <span class="no-like">{{item.favorite_count}}</span>
                  </div>
                  <div v-else @click="deletFavorite(item.id)" class="thumb">
                    <img src="../../assets/images/zhuzhou/icon3.png" alt />
                    <span>{{item.favorite_count}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="hint" v-else>
            <span v-if="access_token&&postList.length==0">暂无信息</span>
          </div>
        </div>
      </div>
      <div v-else class="myReply">
        <div class="myReply_top">
          <div class="title">
            <img src="../../assets/images/zhuzhou/news.png" alt /> 回帖纪录
          </div>
          <el-select @change="handleSelect(2)" v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="myReply_content">
          <ul v-if="access_token&&replyList.length>0">
            <li v-for="(item,index) in replyList" :key="index">
              <img v-if="item.audit_status==1" src="../../assets/images/audit.png" alt />
              <img v-else-if="item.audit_status==3" src="../../assets/images/audit2.png" alt />
              <div>
                <div>
                  <img class="myReply_icon" src="../../assets/images/zhuzhou/icon7.png" alt />
                  <span class="name">{{item.user_name}}</span>回复:
                </div>
                <div class="date">{{item.created_at}}</div>
              </div>
              <p>" {{item.comment}} "</p>
              <div class="from">
                <span>来自帖子</span>
                <router-link
                  :to="{ path: '/forumInfo',query:{pId:item.article_id,title:item.title} }"
                >
                  <span class="title"># {{item.title}} #</span>
                </router-link>
              </div>
            </li>
          </ul>
          <div class="hint" v-else>
            <span v-if="access_token&&replyList.length==0">暂无信息</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="total/page_size>1" class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="page_size"
        :total="total"
        layout="prev, pager, next"
        :prev-text="prevText"
        :next-text="nextText"
        :background="true"
        :hide-on-single-page="true"
      ></el-pagination>
      <div class="amount">共{{total}}篇话题/共{{Math.ceil(total/page_size)}}页</div>
    </div>
    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      width="480px"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="phone">
          <el-input @blur="detectionName" v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入短信验证码"></el-input>
          <el-button :disabled="disabled" type="primary" @click="codeClick">{{codeTxte}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" type="primary" @click="submitForm('ruleForm')">登录</el-button>
      </span>
    </el-dialog>
    <WtDataModal :show="cropperModal" :styles="{width:'340px'}" :isFooter="false">
      <div slot="body">
        <slide-verify
          @success="onSuccess"
          ref="verify"
          @fail="onFail"
          @refresh="onRefresh"
          :slider-text="text"
        ></slide-verify>
      </div>
    </WtDataModal>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
import homeHead from "@/components/Public/head.vue";
import homeNav from "@/components/Public/nav.vue";
import breadcrumb from "@/components/Public/breadcrumb.vue";
import homeFooter from "@/components/Public/footer.vue";
import router from "@/router";

export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "审核中"
        },
        {
          value: "2",
          label: "已发布"
        },
        {
          value: "3",
          label: "审核不通过"
        }
      ],
      value: "2",
      codeTime: "",
      newsData: "",
      cropperModal: false,
      text: "向右拖动滑块填充拼图",
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: "100%",
        //工具栏浮动
        autoFloatEnabled: false,
        // 上传文件接口（
        serverUrl: this.$url.updata.uploadEditor,
        // UEditor 资源文件的存放路径
        UEDITOR_HOME_URL: "./static/UEditor/",
        toolbars: [
          [
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "indent",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "removeformat",
            "formatmatch",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "link",
            "unlink",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "insertimage",
            "insertvideo",
            "|",
            "horizontal",
            "inserttable",
            "insertrow",
            "insertcol",
            "mergecells"
          ]
        ]
      },
      total: 0,
      page: 1,
      page_size: 4,
      access_token: "",
      sidebarList: [
        {
          id: 1,
          name: "话题总览"
        },
        {
          id: 2,
          name: "我的发帖纪录"
        },
        {
          id: 3,
          name: "我的回帖纪录"
        }
      ],
      infoList: [], //话题列表
      ruleForm: {
        phone: "",
        name: "",
        code: ""
      },
      rules: {
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      ruleForm2: {
        title: "",
        content: ""
      },
      rules2: {
        title: [{ required: true, message: "请输入话题标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入话题内容", trigger: "blur" }
        ]
      },

      navId: this.$route.query.send_id || 1,
      imgVisible: "",
      currentPage: 1,
      background: true,
      prevText: "上一页",
      nextText: "下一页",
      applyData: {
        form: {}
      },
      dialogImageUrl: "",
      dialogVisible: false,
      pictureList: [],
      disabled: false,
      codeTxte: "发送验证码",
      key: "",
      code: "", //验证码
      postList: [], //发帖列表
      replyList: [], //回帖列表
      positionData: [
        {
          title: "话题"
        },
        { title: "话题总览" }
      ],
      showTxt: false
    };
  },
  components: {
    homeHead,
    homeNav,
    breadcrumb,
    homeFooter
  },
  created() {
    // this.$db.get(this.$url.channel.childList + "?id=18").then(res => {
    //   this.positionData = res.data;
    //   this.positionData.forEach(element => {
    //     if (element.pid == 0) {
    //       this.title = element.title;
    //     }
    //   });
    // });
    //获取存储的token
    let access_token = sessionStorage.getItem("access_token");
    // sessionStorage.removeItem("access_token");
    if (access_token) {
      this.access_token = access_token;
    }
    if (this.$route.query.send_id == 2) {
      this.getList(this.value);
    } else if (this.$route.query.send_id == 3) {
      this.getReplylist();
    } else {
      this.getInfo();
    }
  },
  methods: {
    //查询姓名
    detectionName() {
      this.$db
        .get(this.$url.login.detection_name, { mobile: this.ruleForm.phone })
        .then(res => {
          if (res.code == 200) {
            this.ruleForm.name = res.data.name;
          }
        }).catch(err => {
            console.log(err);
          });
    },
    tabClick(item) {
      this.navId = item.id;
      const access_token = sessionStorage.getItem("access_token");
      if (access_token) {
        if (item.id == 1) {
          this.page_size = 4;
          router.push({ path: "/forum", query: { send_id: item.id } });
          this.positionData[1].title = "话题总览";
          this.getInfo();
        } else if (item.id == 2) {
          this.page_size = 10;
          router.push({ path: "/forum", query: { send_id: item.id } });
          this.positionData[1].title = "我的发帖记录";
          this.value = "2";
          this.getList(this.value);
        } else if (item.id == 3) {
          this.page_size = 4;
          this.value = "2";
          router.push({ path: "/forum", query: { send_id: item.id } });
          this.positionData[1].title = "我的回帖记录";
          this.getReplylist();
        }
      } else {
        if (item.id == 1) {
          this.page_size = 4;
          router.push({ path: "/forum", query: { send_id: item.id } });
          this.positionData[1].title = "话题总览";
          this.getInfo();
        } else if (item.id == 2) {
          this.page_size = 10;
          this.total = 0;
          this.dialogVisible = true;
          router.push({ path: "/forum", query: { send_id: item.id } });
          this.positionData[1].title = "我的发帖记录";
        } else if (item.id == 3) {
          this.page_size = 4;
          this.total = 0;
          this.dialogVisible = true;
          router.push({ path: "/forum", query: { send_id: item.id } });
          this.positionData[1].title = "我的回帖记录";
        }
      }
    },
    //分页
    handleCurrentChange(val) {
      if (this.navId == 1) {
        this.getInfo();
      } else if (this.navId == 2) {
        this.getList(this.value);
      } else {
        this.getReplylist();
      }
      const returnEle = document.querySelector("#list");
      if (!!returnEle) {
        returnEle.scrollIntoView(true);
      }
    },
    //下拉框
    handleSelect(id) {
      if (id == 1) {
        this.getList(this.value);
      } else {
        this.getReplylist(this.value);
      }
    },
    //关闭登录框
    handleClose(done) {
      if (!this.access_token) {
        this.navId = 1;
        this.getInfo();
      }
      this.$nextTick(() => {
        this.ruleForm.phone = "";
        this.ruleForm.name = "";
        this.ruleForm.code = "";
        clearInterval(this.codeTime);
        this.disabled = false;
        this.codeTxte = "发送验证码";
      });
      done();
    },
    //查询话题列表
    getInfo() {
      if (this.access_token) {
        this.$db
          .get(
            this.$url.topic.list +
              "?page=" +
              this.page +
              "&page_size=" +
              this.page_size,
            { token: true }
          )
          .then(resp => {
            if (resp && resp.data) {
              this.infoList = resp.data.data;
              this.total = resp.data.total;
            }
          }).catch(err => {
            console.log(err);
          });
      } else {
        this.$db
          .get(
            this.$url.topic.list +
              "?page=" +
              this.page +
              "&page_size=" +
              this.page_size
          )
          .then(resp => {
            if (resp && resp.data) {
              this.infoList = resp.data.data;
              this.total = resp.data.total;
            }
          }).catch(err => {
            console.log(err);
          });
      }
    },
    //查询发帖记录
    getList(status) {
      const _this = this;
      _this.$db
        .get(
          _this.$url.topic.post +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size,
          { token: true, audit_status: status ? status : 2 }
        )
        .then(res => {
          if (res.code == 200) {
            _this.postList = res.data.data;
            _this.total = res.data.total;
          }
        }).catch(err => {
            console.log(err);
          });
    },
    //查询回帖记录
    getReplylist(status) {
      const _this = this;
      _this.$db
        .get(
          _this.$url.topic.reply +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size,
          { token: true, audit_status: status ? status : 2 }
        )
        .then(res => {
          if (res.code == 200) {
            _this.replyList = res.data.data;
            _this.total = res.data.total;
          }
        }).catch(err => {
            console.log(err);
          });
    },
    onFail() {

    },
    onRefresh() {

    },
    //获取验证码
    codeClick() {
      if (this.ruleForm.phone == "") {
        this.$message({
          message: "请输入手机号码",
          type: "warning"
        });
        return false;
      } else if (!/^[1][0-9]{10}$/.test(this.ruleForm.phone)) {
        this.$message({
          message: "手机号码格式错误！",
          type: "warning"
        });
        return false;
      } else {
        this.cropperModal = true;
      }
    },
    //滑动验证
    onSuccess() {
      this.cropperModal = false;
      let number = 60;
      let _this = this;
      this.disabled = true;
      let data = {
        mobile: _this.ruleForm.phone
      };
      this.$refs.verify.refresh();
      _this.$db.post(_this.$url.code.send_code, data).then(res => {
        if (res.code == 200) {
          _this.key = res.data.key;
          _this.code = res.data.code;
          if (res.data.code) {
            this.$message(res.data.code);
          }
        }
      }).catch(err => {
            console.log(err);
          });
      let time = setInterval(() => {
        number--;
        this.codeTime = time;
        _this.codeTxte = number + "s";
        if (_this.codeTxte == "0s") {
          clearInterval(time);
          _this.disabled = false;
          _this.codeTxte = "发送验证码";
        }
      }, 1000);
    },
    //用户登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!/^[1][0-9]{10}$/.test(this.ruleForm.phone)) {
            this.$message.error("手机格式错误!");
            return false;
          } else if (!/^[\u4e00-\u9fa5]+$/.test(this.ruleForm.name)) {
            this.$message.error("姓名必须为中文且不能带特殊字符!");
          } else if (this.key == "") {
            this.$message.error("请先获取短信验证码！");
          } else {
            let _this = this;
            let data = {
              mobile: _this.ruleForm.phone,
              key: _this.key,
              code: _this.ruleForm.code,
              name: _this.ruleForm.name
            };
            _this.$db.post(_this.$url.login.user, data).then(res => {
              if (res.code == 200) {
                sessionStorage.setItem("access_token", res.data.access_token);
                _this.dialogVisible = false;
                _this.access_token = res.data.access_token;
                if (this.navId == 1) {
                  _this.getInfo();
                } else if (this.navId == 2) {
                  _this.getList(this.value);
                } else {
                  _this.getReplylist();
                }
                this.$message.success("登录成功！");
              } else {
                this.$message.error(res.msg);
              }
            }).catch(err => {
            console.log(err);
          });
          }
        } else {
          return false;
        }
      });
    },
    //锚点定位
    goAnchor() {
      if (this.access_token) {
        const returnEle = document.querySelector("#publish");
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      } else {
        this.dialogVisible = true;
        const returnEle = document.querySelector("#publish");
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      }
    },
    //如果没有登录，那么弹出登录框
    loginTableOpenByToken() {
      if (!this.access_token) {
        this.dialogVisible = true;
      }
    },
    //话题点赞
    favoriteClick(id, navId) {
      const _this = this;
      this.loginTableOpenByToken();
      if (!this.access_token) {
        return false;
      }
      let data = { article_id: id, token: true };
      if (_this.access_token) {
        _this.$db.post(_this.$url.favorite.add_favorite, data).then(res => {
          if (res.code == 200) {
            if (navId == 1) {
              _this.getInfo();
            } else {
              _this.getList(this.value);
            }
          }
        }).catch(err => {
            console.log(err);
          });
      } else {
        this.$message({
          message: "登录后才能点赞！",
          type: "warning"
        });
      }
    },
    //取消点赞
    deletFavorite(id, navId) {
      this.loginTableOpenByToken();
      if (!this.access_token) {
        return false;
      }
      const _this = this;
      _this.$db
        .delete(_this.$url.favorite.add_favorite + "/" + id, { token: true })
        .then(res => {
          if (res.code == 200) {
            if (navId == 1) {
              _this.getInfo();
            } else {
              _this.getList(this.value);
            }
          }
        }).catch(err => {
            console.log(err);
          });
    },
    //话题发布
    submitClick(formName) {
      const _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          if (!_this.access_token) {
            thi_thiss.dialogVisible = true;
          }
          let params = {
            title: _this.ruleForm2.title,
            content: _this.ruleForm2.content,
            token: true
          };
          _this.$db.post(this.$url.topic.add, params).then(resp => {
            if (resp.code == 200) {
              _this.getInfo();
              _this.ruleForm2.title = "";
              _this.ruleForm2.content = "";
              _this.$message({
                message: "新增话题成功",
                type: "success"
              });
            } else {
              if (resp.code == 401) {
                //登录的弹框
                _this.$message.error("系统检测到您未登录，请登录后操作");
              } else {
                _this.$message.error(resp.msg);
              }
            }
          }).catch(err => {
            console.log(err);
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.forum {
  .colspan {
    margin: 0 auto;
    width: 1200px;
    height: 50px;
    background-color: #f3f3f3;
    color: #888888;
    font-size: 16px;
    margin-top: 14px;
    margin-bottom: 20px;
    > .weizhi {
      float: left;
      line-height: 50px;
      margin-left: 10px;
      > img {
        vertical-align: text-top;
      }
    }
    > .el-breadcrumb {
      line-height: 50px;
    }
  }
  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .list-box {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    margin-top: 50px;
    .sidebar {
      > ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          width: 208px;
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          color: #888888;
          padding: 0 10px;
          cursor: pointer;
          position: relative;
          border: solid 1px #e5e5e5;
          border-bottom: none;
          > .right {
            position: absolute;
            right: 19px;
            top: 50%;
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 1px solid #fff;
            border-radius: 50%;
            color: #fff;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
            transform: translateY(-50%);
          }
        }
        li:nth-of-type(3) {
          border-bottom: solid 1px #e5e5e5;
        }
        .active {
          background-color: #2bba6b;
          color: #eee;
        }
      }
    }
    .topic_box {
      width: 950px;
      .topic_top {
        width: 930px;
        height: 50px;
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        .title {
          height: 50px;
          line-height: 50px;
          font-size: 20px;
          color: #017a37;
          font-weight: 600;
          border-top: 2px solid #017a37;
          > img {
            vertical-align: middle;
            margin-right: 5px;
            margin-top: -4px;
          }
        }
        .button {
          width: 138px;
          height: 50px;
          line-height: 50px;
          background-color: #e9831c;
          border-radius: 5px;
          font-weight: 600;
          font-size: 20px;
          color: #fff;
          text-align: center;
          cursor: pointer;
          > img {
            vertical-align: middle;
            margin-right: 10px;
            margin-top: -4px;
          }
        }
      }
      .topic_content {
        width: 950px;
        margin-top: 16px;
        > ul {
          list-style: none;
          padding: 0;
          min-height: 836px;
          > li {
            width: 776px;
            border: solid 1px #e5e5e5;
            margin-bottom: 40px;
            padding: 27px 140px 29px 34px;
            border-bottom: 2px solid #45d083;
            .content_title {
              display: flex;
              a {
                height: 26px;
                text-decoration: none;
              }
              a:hover {
                height: 25px;
                border-bottom: 1px solid #404040;
              }
              .icon {
                display: inline-block;
                width: 42px;
                height: 22px;
                line-height: 22px;
                font-style: normal;
                background: url("../../assets/images/zhuzhou/icon.png")
                  no-repeat;
                background-size: cover;
                padding-left: 8px;
                font-size: 14px;
                color: #f61414;
                margin-right: 5px;
              }
              .symbol {
                font-size: 20px;
                font-weight: 550;
                color: #e9831c;
                font-family: MicrosoftYaHei;
                margin-right: 5px;
              }
              h3 {
                font-weight: normal;
                color: #404040;
                margin: 0;
                font-size: 20px;
                cursor: pointer;
              }
            }
            .content_info {
              font-size: 16px;
              color: #404040;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .image_box {
              margin-top: 10px;
              cursor: pointer;
              > img {
                width: 224px;
                margin-right: 20px;
              }
            }
            .content_bottom {
              margin-top: 36px;
              color: #888888;
              display: flex;
              .bottom_icon {
                margin-left: 48px;
                display: flex;
                > div {
                  margin-right: 80px;
                  color: #888;
                  > img {
                    margin-right: 5px;
                    margin-top: -5px;
                    vertical-align: middle;
                  }
                }
                .comment {
                  > a {
                    text-decoration: none;
                    color: #888;
                    > img {
                      margin-right: 5px;
                      margin-top: -5px;
                      vertical-align: middle;
                    }
                  }
                }
                .thumb {
                  > img {
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
      .publish {
        width: 818px;
        border: solid 1px #e5e5e5;
        padding: 43px 101px 31px 31px;
        .publish_title {
          font-size: 20px;
          color: #017a37;
          font-weight: 550;
          margin-bottom: 28px;
        }
        .subject {
          width: 800px;
          /deep/ .el-input__inner {
            height: 60px;
            background-color: #f4f4f4;
            margin-bottom: 10px;
          }
          .upload_box {
            width: 784px;
            display: flex;
            flex-flow: wrap;
            border: solid 1px #e5e5e5;
            padding: 16px 0 14px 16px;
            margin-top: 10px;
            /deep/ .el-upload {
              width: 185px;
              height: 150px;
              background-color: #f4f4f4;
              border: 0;
            }
            /deep/ .el-upload-list__item {
              width: 185px;
              height: 150px;
              background-color: #f4f4f4;
              border: 0;
            }
            .img-box {
              position: relative;
              .delete {
                width: 20px;
                height: 20px;
                position: absolute;
                top: -10px;
                right: 8px;
                border-radius: 50%;
                background-color: #eb2121;
                text-align: center;
                color: #fff;
                line-height: 16px;
                cursor: pointer;
              }
            }
          }
          .btn {
            width: 120px;
            height: 56px;
            background-color: #2bba6b;
            text-align: center;
            line-height: 56px;
            font-size: 20px;
            color: #fff;
            margin-top: 20px;
            float: right;
            cursor: pointer;
          }
        }
        .login {
          text-align: center;
          > span {
            color: #017a37;
            margin: 0 10px;
            cursor: pointer;
          }
        }
      }
    }
    .reply_box {
      .reply_top {
        width: 930px;
        height: 50px;
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        .title {
          height: 50px;
          line-height: 50px;
          font-size: 20px;
          color: #017a37;
          font-weight: 700;
          border-top: 2px solid #017a37;
          > img {
            vertical-align: middle;
            margin-right: 5px;
            margin-top: -4px;
          }
        }
      }
      .reply_content {
        width: 950px;
        min-height: 1310px;
        > ul {
          list-style: none;
          padding: 0;
          > li {
            border: solid 1px #e5e5e5;
            border-bottom: 2px solid #45d083;
            padding-left: 25px;
            margin-top: 20px;
            position: relative;
            > img {
              position: absolute;
              top: 0;
              right: 0;
            }
            > a {
              text-decoration: none;
              > h3 {
                font-size: 20px;
                margin: 26px 0 0 0;
                font-weight: normal;
                color: #404040;
                > span {
                  color: #e9831c;
                }
              }
            }
            .content_bottom {
              margin: 30px 0 22px 0;
              color: #888888;
              display: flex;
              .bottom_icon {
                margin-left: 48px;
                display: flex;
                > div {
                  margin-right: 80px;
                  color: #888;
                  > a {
                    text-decoration: none;
                    color: #888;
                    > img {
                      margin-right: 5px;
                      vertical-align: bottom;
                    }
                  }
                }
                .thumb {
                  cursor: pointer;
                }
              }
            }
          }
        }
        .hint {
          text-align: center;
          line-height: 100px;
        }
      }
      .login {
        text-align: center;
        height: 149px;
        line-height: 150px;
        border: 1px solid #e5e5e5;
        margin-top: 16px;
        > span {
          color: #017a37;
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .myReply {
      .myReply_top {
        width: 930px;
        height: 50px;
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        .title {
          height: 50px;
          line-height: 50px;
          font-size: 20px;
          color: #017a37;
          font-weight: 600;
          border-top: 2px solid #017a37;
          > img {
            vertical-align: middle;
            margin-right: 5px;
            margin-top: -4px;
          }
        }
      }
      .myReply_content {
        min-height: 844px;
        > ul {
          list-style: none;
          padding: 0;
          > li {
            width: 930px;
            height: 188px;
            background-color: #ffffff;
            border: solid 1px #e5e5e5;
            padding: 20px 0 0 20px;
            margin-bottom: 35px;
            border-bottom: 2px solid #45d083;
            position: relative;
            > img {
              position: absolute;
              top: 0;
              right: 0;
            }
            > div {
              display: flex;
              justify-content: space-between;
              .myReply_icon {
                width: 32px;
                height: 32px;
                vertical-align: middle;
              }
              .date {
                color: #888;
                margin-right: 70px;
              }
              .name {
                color: #2bba6b;
                margin: 0 5px;
              }
            }

            > p {
              margin: 0;
            }
            span:nth-of-type(2) {
              color: #2bba6b;
              margin: 0 5px;
            }
            p:nth-of-type(1) {
              color: #404040;
              margin: 21px 31px 15px 46px;
            }
            .from {
              color: #888;
              display: inline-block;
              width: 859px;
              height: 66px;
              line-height: 66px;
              background-color: #f8f8f8;
              margin: 0 0 33px 35px;
              > span {
                margin-left: 18px;
              }
              > a {
                text-decoration: none;
                color: #2bba6b;
              }
            }
          }
        }
        .hint {
          text-align: center;
          line-height: 100px;
        }
      }
      .login {
        text-align: center;
        height: 149px;
        line-height: 150px;
        border: 1px solid #e5e5e5;
        margin-top: 16px;
        > span {
          color: #017a37;
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .amount {
      height: 26px;
      line-height: 28px;
      border: 1px solid #dcdfe6;
      padding: 0 10px;
      font-size: 13px;
      color: #888;
      margin-top: 52px;
    }
    /deep/ .el-pagination {
      margin: 50px 0 0 550px;
    }
  }
}

/deep/ .el-input__inner::placeholder {
  font-size: 16px;
  color: #888;
}
/deep/ .el-textarea .el-textarea__inner {
  min-height: 182px !important;
  background-color: #f4f4f4;
  color: #000;
}
/deep/ .el-textarea .el-textarea__inner::placeholder {
  color: #888;
  font-size: 16px;
  font-family: "MicrosoftYaHei";
}
/deep/ .el-icon-plus:before {
  content: "\e79b";
  display: inline-block;
  line-height: 150px;
  color: #888;
}
/deep/ .el-pagination {
  display: flex;
  justify-content: center;
  /deep/ .el-pager li {
    color: #888;
  }
  /deep/ button span {
    color: #888;
  }
  /deep/ .el-pager li.active {
    color: #fff !important;
  }
}
/deep/ .btn {
  width: 100%;
  background-color: #2bba6b;
  > span {
    font-size: 20px;
  }
}
/deep/ .el-form-item__content {
  display: flex;
  /deep/ .el-input__inner {
    border-radius: 0;
  }
  .el-button--primary {
    padding: 0;
    width: 120px;
    height: 40px;
    border-radius: 0;
    background-color: #f3f3f3;
    padding: 0 15px;
    border-color: #e0e0e0;
    color: #2bba6b;
    border-left: none;
  }
}
/deep/ .el-input__inner::placeholder {
  color: #8f8787;
}
/deep/ .el-pagination {
  display: flex;
  justify-content: center;
  /deep/ .el-pager li {
    color: #888;
  }
  /deep/ button span {
    color: #888;
  }
  /deep/ .el-pager li:hover {
    color: #2bba6b !important;
  }
  /deep/ .el-pager li.active {
    background-color: #2bba6b !important;
  }
}
/deep/ .el-dialog {
  height: 428px;
  padding: 50px 65px 68px 65px;
}
/deep/ .el-dialog__header {
  padding: 0;
  margin: 0 0 35px 13px;
}
/deep/ .el-dialog__title {
  font-size: 24px;
  margin-bottom: 25px;
}
/deep/ .el-input {
  margin-bottom: 12px;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .el-dialog__footer {
  padding: 0;
  margin-top: 59px;
}
/deep/ .el-button--primary {
  border-color: #fff;
}
/deep/ .el-input {
  margin-bottom: 0;
}
/deep/ .el-upload-list {
  display: none !important;
}
/deep/ .content_info {
  img {
    width: 100%;
    display: none;
  }
  p {
    margin: 0;
  }
}
/deep/ .edui-editor {
  z-index: 0 !important;
}
/deep/ .edui-combox-body {
  height: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/forum/index.vue